import React, { useEffect, useRef } from "react";
import MainLayout from "../../layout";
import { TextView } from "../../components/view-form-components/text-view";
import { DocumentView } from "../../components/view-form-components/image.view";
import { useState } from "react";
import axios from "axios";
import { url } from "../../config";
import { useNavigate, useParams } from "react-router-dom";
import DeleteModal from "../../components/modal/delete-modal";
import backArrow from "../../assets/icons/back-arrow.svg";
import moment from "moment";
import { Loader } from "lucide-react";
import CreateLocationModal from "../../components/modal/location-create-modal";
import EditLocationModal from "../../components/modal/location-edit-modal";
import Papa from "papaparse";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";

const ReadCity = () => {
  const params = useParams();
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [listData, setListData] = useState();
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [createLocationModalShow, setCreateLocationModalShow] = useState(false);
  const [editLocationModalShow, setEditLocationModalShow] = useState(false);
  const [deleteLocationModalShow, setdeleteLocationModalShow] = useState(false);
  const [selectedItem, setselectedItem] = useState(null);

  const fetchData = () => {
    setLoading(true);
    axios
      .post(`${url}/model/city/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const fetchLocationData = () => {
    setLoading(true);
    axios
      .post(`${url}/city/locality/list`, { city_id: params?.id })
      .then((res) => {
        setListData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    fetchLocationData();
  }, []);

  const deleteFnc = (id) => {
    axios
      .post(`${url}/model/city/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        navigate("/admin/users/list");
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const locationDeleteFnc = (id) => {
    axios
      .post(`${url}/model/locality/delete`, {
        id: id,
      })
      .then((res) => {
        fetchLocationData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const handleCsvUpload = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async function (results) {
        const formattedData = results.data.map((row) => ({
          main_location: row.main_location,
          sub_location: row.sub_location || null,
          location_link: row.location_link || null,
        }));

        try {
          const res = await axios.post(`${url}/city/locality/bulk-create`, {
            city_id: params?.id,
            localities: formattedData,
          });
          const backendMessage = res.data?.message || "Bulk upload successful";

          successToast(backendMessage);
          fetchLocationData();
        } catch (error) {
          const serverMessage =
            error.response?.data?.message || "An unexpected error occurred";
          errorToast(serverMessage);
        }

        event.target.value = null;
      },
    });
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <CreateLocationModal
        isOpen={createLocationModalShow}
        onClose={() => {
          setCreateLocationModalShow(false);
        }}
        listFnc={fetchLocationData}
      />
      <EditLocationModal
        isOpen={editLocationModalShow}
        onClose={() => {
          setEditLocationModalShow(false);
        }}
        data={selectedItem}
        listFnc={fetchLocationData}
      />
      <DeleteModal
        isOpen={deleteLocationModalShow}
        onClose={() => {
          setdeleteLocationModalShow(false);
        }}
        btnFnc={() => locationDeleteFnc(selectedItem?.id)}
      />
      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <div className="flex items-center gap-2">
            <button onClick={() => navigate(-1)} type="button">
              <img src={backArrow} alt="<" width={10} height={10} />
            </button>
            <h2 className="text-xl font-semibold capitalize">City - view</h2>
          </div>
          <div className="flex items-center gap-5">
            <button
              onClick={() => navigate(`/city/edit/${params?.id}`)}
              className="px-4 py-1 bg-white border-[2px] border-primary text-primary rounded"
            >
              Edit
            </button>
            <button
              onClick={() => {
                setdeleteModalShow(true);
              }}
              className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
            >
              Delete
            </button>{" "}
          </div>
        </div>

        <section className="w-full max-w-[40rem]">
          <TextView
            label={"country cites"}
            value={data?.country_cites?.name ?? "--"}
          />
          <TextView label={"name"} value={data?.name} />
          <DocumentView label={"image url"} value={data?.image_url} />
          <TextView label={"location link"} value={data?.location_link} />{" "}
          <TextView
            label={"created At"}
            value={moment(data?.createdAt).format("DD-MM-YYYY HH:MM A")}
          />{" "}
          <TextView
            label={"updated At"}
            value={moment(data?.updatedAt).format("DD-MM-YYYY HH:MM A")}
          />
        </section>

        <section>
          <div className="flex justify-end m-2 gap-2">
            <button
              type="button"
              onClick={() => setCreateLocationModalShow(true)}
              className="bg-primary border border-primary text-white px-3 py-1 rounded-md text-fs_14"
            >
              Create
            </button>

            <button
              type="button"
              onClick={() => fileInputRef.current.click()}
              className="border border-primary text-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
            >
              Upload
            </button>

            <input
              ref={fileInputRef}
              type="file"
              accept=".csv"
              onChange={handleCsvUpload}
              className="hidden"
            />
          </div>
          <table class="w-full text-left rtl:text-right border border-gray-200">
            <thead class="text-gray-700 uppercase">
              <tr>
                <th
                  scope="col"
                  class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                >
                  #
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                >
                  id
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                >
                  main location
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                >
                  sub location
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                >
                  created At
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 capitalize text-fs_16 font-fw_600"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td rowSpan={1}>
                    <div className="w-full flex justify-center py-5">
                      <div className="h-[100px] w-[100px]">
                        <Loader />
                      </div>
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {listData?.rows?.length ? (
                    <>
                      {listData?.rows.map((row, index) => {
                        return (
                          <tr key={index} className="border-t bg-white">
                            <td className="p-1 px-2">
                              {(listData?.page - 1) * 10 + (index + 1)}
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.id}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.main_location ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.sub_location ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2">
                              {moment(row?.createdAt).format(
                                "DD-MM-YYYY hh:mm:ss A",
                              )}
                            </td>

                            <td className="py-2 sticky right-0 z-0">
                              <div className="flex gap-3 bg-white px-4">
                                {/* <Link
                                  to={`/blogs/view/${row["id"]}`}
                                  className="text-secondary border-[1px] border-secondary px-3 py-1 rounded-md text-fs_14 hover:bg-green-50"
                                >
                                  View
                                </Link>*/}
                                <button
                                  type="button"
                                  onClick={() => {
                                    setEditLocationModalShow(true);
                                    setselectedItem(row);
                                  }}
                                  className="text-primary border-[1px] border-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
                                >
                                  Edit
                                </button>
                                <button
                                  onClick={() => {
                                    setdeleteLocationModalShow(true);
                                    setselectedItem(row);
                                  }}
                                  className="text-errorColor border-[1px] border-errorColor px-3 py-1 rounded-md text-fs_14 hover:bg-red-50"
                                >
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    <tr>
                      <td>
                        <p className="text-center my-5">No data found</p>
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </section>
      </section>
    </MainLayout>
  );
};

export default ReadCity;
